<template>
  <div class="d-flex gept_main_color font-weight-bold mb-3 text-lg">
    <!-- 問題文字 -->
    <p class="mr-2 text-nowrap d-none d-md-block h4 mb-0">問題</p>

    <!-- 題號 -->
    <div
      class="d-flex align-items-center flex-wrap"
      v-for="(item, index) in questionData.Questions"
      :key="index"
    >
      <div class="d-flex align-items-center">
        <!-- 題號本體 -->
        <div class="position-relative mx-md-1">
          <p
            class="gept_main_color6 mb-0"
            :class="{ active: index === actionIdx }"
          >
            {{ index + 1 }}
          </p>

          <!-- 已完成勾勾 -->
          <div
            class="position-absolute question_order_check"
            v-if="ERS_arr[index]"
          >
            <img
              src="@/assets/image/gept/question_order_check.png"
              class="img-fluid"
            >
          </div>
        </div>

        <!-- 連線圖 -->
        <div
          class="d-flex align-items-center mx-2"
          v-if="index < questionData.Questions.length - 1"
        >
          <img
            src="@/assets/image/gept/question_order_line.png"
            class="img-fluid d-none d-md-inline-block"
          >
          <img
            src="@/assets/image/gept/question_order_lineM.png"
            class="img-fluid d-inline-block d-md-none"
          >
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  export default {
    name: 'question_order',
    props: {
      actionIdx: {
        type: Number,
        default: 0
      },
      questionData: {
        type: Object
      },
      ERS_arr: {
        type: Array
      }
    },
    data () {
      return {
      }
    },

    computed: {
    },
    mounted () {
    },
    methods: {
      isEmpty (obj) {
        return Object.keys(obj).length === 0
      }
    }
  }
</script>

<style lang="scss" scoped>
.question_order_check {
  top: 30%;
  right: -50%;
}
.active {
  color: #145F7F;
}
</style>
